class LoggerCore {

}

export default LoggerCore;
